"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseParams = exports.globalConfig = void 0;
const panorama_client_web_1 = require("@wix/panorama-client-web");
exports.globalConfig = (0, panorama_client_web_1.createGlobalConfig)();
exports.baseParams = {
    platform: panorama_client_web_1.PanoramaPlatform.Standalone,
    fullArtifactId: 'com.wixpress.payment.cashier-payments-widget',
    componentId: 'cashier-payments-widget',
};
//# sourceMappingURL=config.js.map